import { Helmet } from 'react-helmet';
import Services from '../components/Services';

export default function ServicesPage() {
  return (
    <>
      <Helmet>
        <title>Services | The Prisu Experts</title>
        <meta
          name="description"
          content="Explore our full range of AI data services including annotation, transcription, dubbing, video editing, content creation, and more."
        />
      </Helmet>
      <Services />
    </>
  );
}
